import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row row-cols-2 g-5" }
const _hoisted_2 = { class: "row row-cols-4 g-5" }
const _hoisted_3 = { class: "row row-cols-4 g-5" }
const _hoisted_4 = {
  key: 0,
  class: "row row-cols-4 g-5"
}
const _hoisted_5 = {
  key: 1,
  class: "row row-cols-2 g-5"
}
const _hoisted_6 = { class: "dialog-footer" }

import { ref, reactive } from "vue";
import { weekdayOptions } from "@/core/types/documents/ContracSpecsTypes";
import { bviMargins } from "@/core/types/documents/ContracSpecsTypes";
import type { FormInstance } from "element-plus";
import DocsServices from "../../services/DocsServices";
import { ElNotification } from "element-plus";
import { useStore } from "@/store";

export default /*#__PURE__*/_defineComponent({
  __name: 'EditContract',
  emits: ["eventSubmit"],
  setup(__props, { expose: __expose, emit }) {

const store = useStore();
const user = store.state.AuthModule.user;
const dialogRef = ref(false);
const id = ref(0);
const site = ref("bvi");
const isLoading = ref(false);
const ruleFormRef = ref<FormInstance>();
const auMargins = ref<any>([]);
const formData = ref<any>({});
const show = (item: any) => {
  formData.value = item;
  id.value = item.id;
  site.value = item.site;
  if (site.value == "ba") {
    processAUMargins(item.margin_requirements);
  }
  dialogRef.value = true;
};

const processAUMargins = (margins: any) => {
  for (const key in margins) {
    if (Object.prototype.hasOwnProperty.call(margins, key)) {
      auMargins.value.push({
        label: key,
        value: margins[key],
      });
    }
  }
};

const rules = reactive<any>({
  trading_start_time: [
    {
      required: true,
      message: "Please input Trading Start Time",
      trigger: "blur",
    },
  ],
  trading_end_time: [
    {
      required: true,
      message: "Please input Trading End Time",
      trigger: "blur",
    },
  ],
  trading_start_weekday: [
    {
      required: true,
      message: "Please input Trading Start Weekday",
      trigger: "blur",
    },
  ],
  trading_end_weekday: [
    {
      required: true,
      message: "Please input Trading End Weekday",
      trigger: "blur",
    },
  ],
  contract_size: [
    { required: true, message: "Please input Contract Size", trigger: "blur" },
  ],
});

const getOperatorData = async () => {
  const operatorData = formData.value.operator_info ?? [];

  const data = {
    name: user.nativeName,
    email: user.email,
    updatedAt: new Date().toISOString(),
  };

  // Add the new data to the beginning of the array
  operatorData.unshift(data);

  // Limit the array to the latest 5 entries
  if (operatorData.length > 5) {
    operatorData.pop();
  }

  // Update the formData with the modified operator_info array
  formData.value.operator_info = operatorData;
};

const submitForm = async () => {
  if (!ruleFormRef.value) return;
  let isValid = false;
  isLoading.value = true;
  await ruleFormRef.value.validate(async (valid) => {
    isValid = valid;
  });
  if (!isValid) {
    isLoading.value = false;
    return;
  }
  try {
    if (site.value == "ba") {
      formData.value.margin_requirements = {};
      auMargins.value.forEach((margin: any) => {
        formData.value.margin_requirements[margin.label] = margin.value;
      });
    }
    await getOperatorData();
    await DocsServices.updateContractSpecs(id.value, formData.value);
    ElNotification({
      title: "Success",
      message: "Contract Spec updated successfully",
      type: "success",
    });
    dialogRef.value = false;
    emit("eventSubmit");
  } catch (error) {
    console.error(error);
    ElNotification({
      title: "Error",
      message: "Update Contract Spec failed",
      type: "error",
    });
  }
  isLoading.value = false;
};



__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogRef.value,
    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((dialogRef).value = $event)),
    title: _ctx.$t('fields.EditContract'),
    width: "900",
    "align-center": ""
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_button, {
          onClick: _cache[12] || (_cache[12] = ($event: any) => (dialogRef.value = false)),
          disabled: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "warning",
          onClick: submitForm,
          loading: isLoading.value,
          plain: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.submit")), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: formData.value,
        rules: rules,
        "label-width": "70px",
        class: "demo-ruleForm",
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.symbol'),
              prop: "symbol"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.symbol,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.symbol) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.category'),
              prop: "category"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.category,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.category) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.tradeStartTime'),
              prop: "trading_start_time"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_time_picker, {
                  format: "HH:mm",
                  "value-format": "HH:mm",
                  modelValue: formData.value.trading_start_time,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.trading_start_time) = $event)),
                  disabled: isLoading.value,
                  class: "w-200px"
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.tradeEndTime'),
              prop: "trading_end_time"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_time_picker, {
                  format: "HH:mm",
                  "value-format": "HH:mm",
                  modelValue: formData.value.trading_end_time,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.trading_end_time) = $event)),
                  disabled: isLoading.value,
                  class: "w-200px"
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.tradeStartWeekDay'),
              prop: "trading_start_weekday"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: formData.value.trading_start_weekday,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.trading_start_weekday) = $event)),
                  disabled: isLoading.value
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(weekdayOptions), (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.tradeEndWeekDay'),
              prop: "trading_end_weekday"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: formData.value.trading_end_weekday,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.trading_end_weekday) = $event)),
                  disabled: isLoading.value
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(weekdayOptions), (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.breakStartTime')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_time_picker, {
                  format: "HH:mm",
                  "value-format": "HH:mm",
                  modelValue: formData.value.break_start_time,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.break_start_time) = $event)),
                  disabled: isLoading.value,
                  class: "w-200px"
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.breakEndTime')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_time_picker, {
                  format: "HH:mm",
                  "value-format": "HH:mm",
                  modelValue: formData.value.break_end_time,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.break_end_time) = $event)),
                  disabled: isLoading.value,
                  class: "w-200px"
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.breakStartTime') + '- 2'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_time_picker, {
                  format: "HH:mm",
                  "value-format": "HH:mm",
                  modelValue: formData.value.more_break_start_time,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.more_break_start_time) = $event)),
                  disabled: isLoading.value,
                  class: "w-200px"
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.breakEndTime') + '- 2'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_time_picker, {
                  format: "HH:mm",
                  "value-format": "HH:mm",
                  modelValue: formData.value.more_break_end_time,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.more_break_end_time) = $event)),
                  disabled: isLoading.value,
                  class: "w-200px"
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.contractSize'),
              prop: "contract_size"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: formData.value.contract_size,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.contract_size) = $event)),
                  disabled: isLoading.value,
                  class: "w-200px"
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.commission')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: formData.value.commission,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.commission) = $event)),
                  disabled: isLoading.value,
                  class: "w-200px"
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("h6", null, _toDisplayString(_ctx.$t("fields.marginRequirement")), 1),
          (site.value == 'bvi')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bviMargins), (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_form_item, {
                    key: index,
                    label: item.label
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formData.value.margin_requirements[item.value],
                        "onUpdate:modelValue": ($event: any) => ((formData.value.margin_requirements[item.value]) = $event),
                        class: "w-200px",
                        disabled: isLoading.value
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(auMargins.value, (margin, key) => {
                  return (_openBlock(), _createBlock(_component_el_form_item, { key: key }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        class: "w-100px",
                        modelValue: margin.label,
                        "onUpdate:modelValue": ($event: any) => ((margin.label) = $event),
                        disabled: isLoading.value
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                      _createVNode(_component_el_input, {
                        class: "w-100px ms-2",
                        modelValue: margin.value,
                        "onUpdate:modelValue": ($event: any) => ((margin.value) = $event),
                        disabled: isLoading.value
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]))
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})